import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1c5b2821"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header"
};
const _hoisted_2 = {
  class: "navbar"
};
const _hoisted_3 = {
  key: 0,
  class: "dropdown"
};
const _hoisted_4 = {
  class: "fs-xs"
};
const _hoisted_5 = {
  class: "dropdown-content text-blue fs-xxs"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  key: 1,
  class: "fs-xs"
};
const _hoisted_8 = {
  class: "phone-box"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text-white fs-xxs"
}, "WELLCH_QC@carbon-hp.com", -1));
import { ref, onMounted, nextTick } from 'vue';
import { useRouter } from 'vue-router';
import { WOW } from 'wowjs';
import { Message } from '@element-plus/icons-vue';
export default {
  __name: 'PcHeader',
  setup(__props) {
    const router = useRouter();
    const menuList = [{
      title: '首页',
      id: '1',
      url: '/'
    },
    // { title: '标准', id: '2', children: [
    //     { title: '园区数智控碳体系创建与评价标准', id: '2-1', url: '/pdf/park' },
    //     { title: '碳手印项目咨询标准', id: '2-2', url: '/pdf/consult' },
    //     { title: '温室气体自愿减排项目方法学', id: '2-3', url: '/pdf/meth' },
    //   ] 
    // },
    {
      title: '活动中心',
      id: '3',
      children: [{
        title: '最佳实践项目评级',
        id: '3-1',
        url: '/project-active'
      },
      // { title: '高峰论坛', id: '3-2', url: '' },
      {
        title: '碳手印投资',
        id: '3-3',
        url: '/invest'
      }, {
        title: '碳手印倡议',
        id: '3-4',
        url: '/initiative'
      }, {
        title: '未来城市美学赛道',
        id: '3-0',
        url: '/aiot'
      }
      // { title: '项目辅导', id: '3-5', url: '' },
      ]
    }, {
      title: '互动群体',
      id: '4',
      children: [{
        title: '碳友团',
        id: '4-1',
        url: '/carbon-friend'
      }, {
        title: '会员计划',
        id: '4-2',
        url: '/member'
      }, {
        title: '成为赋能官',
        id: '4-3',
        url: '/export'
      }]
    }, {
      title: '资源中心',
      id: '5',
      children: [{
        title: '知识库',
        id: '5-1',
        url: '/knowledge-base'
      }, {
        title: '项目库',
        id: '5-2',
        url: '/video-base'
      }, {
        title: '产品库',
        id: '5-3',
        url: '/product-base'
      }
      // { title: '服务库', id: '5-4', url: '/service-base' },
      ]
    }, {
      title: '关于我们',
      id: '6',
      url: '/about'
    }];
    onMounted(() => {
      nextTick(() => {
        new WOW({
          live: false,
          offset: 0
        }).init();
      });
    });
    const toHome = function () {
      router.push({
        path: '/'
      });
    };
    const toPage = url => {
      router.push({
        path: url
      });
    };
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      const _component_el_icon = _resolveComponent("el-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        class: "title fs-l fw-b",
        onClick: toHome
      }, "WELL碳手印"), _createElementVNode("nav", null, [_createElementVNode("ul", null, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuList, menu => {
        return _createElementVNode("li", null, [menu.children ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("a", _hoisted_4, _toDisplayString(menu.title), 1), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.children, menuItem => {
          return _openBlock(), _createElementBlock("div", {
            class: "dropdown-content-item",
            onClick: $event => toPage(menuItem.url)
          }, _toDisplayString(menuItem.title), 9, _hoisted_6);
        }), 256))])])) : (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_router_link, {
          to: menu.url,
          style: {
            "cursor": "pointer"
          }
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(menu.title), 1)]),
          _: 2
        }, 1032, ["to"])]))]);
      }), 64))])]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_icon, {
        size: "18",
        color: "#fff"
      }, {
        default: _withCtx(() => [_createVNode(_unref(Message))]),
        _: 1
      }), _hoisted_9])])]);
    };
  }
};